module.exports = __webpack_public_path__ + "202408221624/img/ai.ed7dd81e.png";